import React, { useState } from 'react';
import { X } from 'lucide-react';

const Gallery = ({ series }) => {
  const [selectedArtwork, setSelectedArtwork] = useState(null);

  return (
    <>
      <div className="bg-off-black py-16 sm:py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Series organized sections */}
          {series.map((seriesItem, idx) => (
            <div key={seriesItem.id} className={idx > 0 ? 'mt-24 sm:mt-32 md:mt-48' : ''}>
              {/* Series Header */}
              <div className="mb-8 sm:mb-12 md:mb-16">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-soft-ivory mb-3 sm:mb-4 tracking-tight">
                  {seriesItem.name}
                </h2>
                <p className="text-muted-warm-grey text-base sm:text-lg tracking-wide">
                  {seriesItem.description}
                </p>
              </div>

              {/* Artworks Grid - Mobile Responsive */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12 md:gap-16 lg:gap-24">
                {seriesItem.artworks.map((artwork) => (
                  <div
                    key={artwork.id}
                    className="group cursor-pointer"
                    onClick={() => setSelectedArtwork(artwork)}
                  >
                    <div className="relative overflow-hidden bg-deep-charcoal aspect-[4/5] mb-4 sm:mb-6">
                      <img
                        src={artwork.image}
                        alt={artwork.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                      />
                    </div>
                    <div className="space-y-1 sm:space-y-2">
                      <h3 className="text-lg sm:text-xl font-serif text-soft-ivory tracking-wide">
                        {artwork.title}
                      </h3>
                      <p className="text-xs sm:text-sm text-muted-warm-grey tracking-wider">
                        {artwork.medium} • {artwork.year}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Artwork Detail Modal - WHITE BOX - Mobile Responsive */}
      {selectedArtwork && (
        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-3 sm:p-6 animate-fade-in overflow-y-auto"
          onClick={() => setSelectedArtwork(null)}
        >
          <button
            className="absolute top-4 right-4 sm:top-8 sm:right-8 text-white hover:opacity-60 transition-opacity duration-400 z-10"
            onClick={() => setSelectedArtwork(null)}
          >
            <X size={28} strokeWidth={1.5} className="sm:w-8 sm:h-8" />
          </button>
          
          {/* WHITE CONTENT BOX */}
          <div
            className="max-w-7xl w-full bg-white rounded-sm shadow-2xl overflow-hidden my-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
              {/* Image Side */}
              <div className="relative bg-zinc-100 flex items-center justify-center p-4 sm:p-8 md:p-12">
                <img
                  src={selectedArtwork.image}
                  alt={selectedArtwork.title}
                  className="w-full h-auto max-h-[50vh] sm:max-h-[70vh] object-contain"
                />
              </div>
              
              {/* Text Side */}
              <div className="p-6 sm:p-8 md:p-12 flex flex-col justify-center space-y-4 sm:space-y-6 bg-white">
                <div>
                  <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif text-black tracking-tight mb-2 sm:mb-3">
                    {selectedArtwork.title}
                  </h2>
                  <p className="text-xs sm:text-sm uppercase tracking-widest text-zinc-500">
                    {selectedArtwork.category}
                  </p>
                </div>
                
                <div className="space-y-2 sm:space-y-3 text-black border-t border-zinc-200 pt-4 sm:pt-6">
                  <p className="text-sm sm:text-base md:text-lg">{selectedArtwork.year}</p>
                  <p className="text-sm sm:text-base md:text-lg">{selectedArtwork.medium}</p>
                  <p className="text-sm sm:text-base md:text-lg">{selectedArtwork.dimensions}</p>
                </div>
                
                {selectedArtwork.description && (
                  <div className="border-l-2 border-flesh-tone pl-4 sm:pl-6 py-2">
                    <p className="text-sm sm:text-base leading-relaxed text-black">
                      {selectedArtwork.description}
                    </p>
                  </div>
                )}
                
                {selectedArtwork.price && (
                  <div className="pt-4 sm:pt-6 border-t border-zinc-200">
                    <p className="text-base sm:text-lg text-black font-medium">{selectedArtwork.price}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
